export default "/images/vendor/flag-icon-css/flags/4x3/au.svg?932d918261bcbb88f0cc22baa8e5f32f";